/**
 * Created by dinesh on 13/6/17.
 */
import { Component, ElementRef, OnInit, ViewChild, HostListener  } from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../shared/authorization.service';
import {KeyValue} from '../../shared/key-value';


@Component({
  selector: 'app-licence-terms',
  templateUrl: 'licence.component.html'
})
export class LicenceComponent implements OnInit {

  @ViewChild('myModal') modal: ElementRef;
  constructor(private router: Router, private _tokenService: AngularTokenService,
  public authService: AuthorizationService) {
    console.log(this.authService.licenceRejected);
  }

  ngOnInit() {
    console.log(' in init ... '+this.authService.licenceRejected)
    document.getElementById('login-alert').style.display = 'none'
      if (this.authService.licenceRejected==false){
        this.router.navigate([KeyValue.changePasswordPath]);
      }
    }

    onModalShown() {
      const firstFocusableElement = this.modal.nativeElement.querySelector('.modal-body h4:first-of-type') as HTMLElement;
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }
  
    onModalHidden() {
      const loginButton = document.querySelector('.login-button') as HTMLElement;
      if (loginButton) {
        loginButton.focus();
      }
    }
  
  licenceAgree() {
    console.log('update terms');
    this.authService.agreeTerms();
  }

  licenceDisagree() {
    this.authService.licenceDisagree();
  }

  @HostListener('document:keydown.tab', ['$event'])
trapTabKey(event: KeyboardEvent) {
  if (this.modal.nativeElement.contains(document.activeElement) && event.key === 'Tab') {
    event.preventDefault();
    const focusableElements = this.modal.nativeElement.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
    const focusedElement = document.activeElement as HTMLElement;
    const currentIndex = Array.from(focusableElements).indexOf(focusedElement);

    if (currentIndex === focusableElements.length - 1) {
      // If the last focusable element is focused, set focus to the first one
      const firstFocusable = focusableElements[0] as HTMLElement;
      firstFocusable.focus();
    } else {
      // Otherwise, set focus to the next focusable element
      const nextFocusable = focusableElements[currentIndex + 1] as HTMLElement;
      nextFocusable.focus();
    }
  }
}

}
